import { render, staticRenderFns } from "./VaimoProducts.vue?vue&type=template&id=14edb941&scoped=true&"
import script from "./VaimoProducts.vue?vue&type=script&lang=ts&"
export * from "./VaimoProducts.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoProducts.vue?vue&type=style&index=0&id=14edb941&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14edb941",
  null
  
)

export default component.exports